import { Form } from "react-bulma-components";
import { Icon } from "react-bulma-components";
import { Button } from "react-bulma-components";
import React, {useEffect, useState} from "react";
import FAIcon from "../components/Icon/FAIcon";
import useInlineEditButton from "./useInlineEditButton";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";

function useEditableTableTypeaheadCell({
    propName,
    value,
    onChange,
    onSave,
    editable,
    setEditable,
    disabled,
    inlineEdit,
    labelKey,
    searchUrl,
    placeholder
}) {
    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState(value ? [value] : []);
    const [, setTypeahead] = useState();
    const handleSearch = e => {
        const url = searchUrl.indexOf('?') === -1 ? `${searchUrl}?` : searchUrl;
        setLoading(true);
        axios.get(`${url}&search=${e}`).then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
        });
    };

    const handleValueSelect = inputValue => {
        const selectedValue = inputValue[0];
        onChange({target: {name: propName, value: selectedValue}});
    };

    return <td onClick={e => e.stopPropagation()}>
        <Form.Field className="has-addons">
            <Form.Control>
                <AsyncTypeahead
                    useCache={false}
                    id="typeahead"
                    labelKey={labelKey}
                    minLength={2}
                    name={propName}
                    onSearch={handleSearch}
                    onChange={handleValueSelect}
                    placeholder={placeholder}
                    options={searchData ? searchData : [value]}
                    ref={typeahead => setTypeahead(typeahead)}
                    className="typeahead"
                    isLoading={isLoading}
                    defaultSelected={
                        value ? [value] : []
                    }
                    disabled={!editable}
                />
            </Form.Control>
            {useInlineEditButton({show: inlineEdit, onSave, setEditable, editable, disabled})}
        </Form.Field>
    </td>;
}

export default useEditableTableTypeaheadCell;
